import { render, staticRenderFns } from "./AuthTokenSetupDialog.vue?vue&type=template&id=3037c035&scoped=true"
import script from "./AuthTokenSetupDialog.vue?vue&type=script&lang=ts"
export * from "./AuthTokenSetupDialog.vue?vue&type=script&lang=ts"
import style0 from "./AuthTokenSetupDialog.vue?vue&type=style&index=0&id=3037c035&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3037c035",
  null
  
)

export default component.exports